module.exports = __webpack_public_path__ + "static/img/tab2.a0c1d022.png";